import axios from 'axios';

export const inovePagarme = axios.create({
    baseURL: 'http://localhost:3001/api',
    //baseURL: 'https://pagarme.inoveclube.com/api',
})
